import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a054802"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "versionText" }

import { ref, onMounted, computed } from 'vue'
import { queryDeviceUpgradeRecordPage } from '@/api'
import { PAGE_SIZES, CODE_ENUM, PRODUCT_TYPE } from '@/common'
import { useRoute } from 'vue-router'
import moment from 'moment'


export default /*#__PURE__*/_defineComponent({
  __name: 'upgrade-table',
  props: ['data'],
  setup(__props) {

const $route = useRoute()

const props = __props

const verseionText = computed(() => {
  const str = (props.data?.chipInfo || [])
    .map(({ chipType, version }: any) => {
      return `${chipType} : ${version}`
    })
    .join('     ')
  return str ? `当前版本：   ${str}` : ''
})

const deviceId = $route.query.deviceId || ''

const textMap: any = {
  succ: '成功',
  fail: '失败',
  receive: '升级中',
  run_timeout: '无响应',
  run_fail: '下发失败',
}

const statusMap: any = {
  succ: 'primary',
  fail: 'warning',
  receive: 'primary',
  run_timeout: 'info',
  run_fail: 'danger',
}

const tableData = ref([])
const tableLoading = ref(false)

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const fetchList = async () => {
  tableLoading.value = true
  const res: any = await queryDeviceUpgradeRecordPage({
    ...pageParams.value,
    deviceId,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

const isDirectDevice = ref(false)

onMounted(() => {
  if (PRODUCT_TYPE.DIRECT_CONNECT === props.data?.productTypeCode) {
    isDirectDevice.value = true
    return
  }
  fetchList()
})

const tableColumn: any = [
  {
    prop: 'chipType',
    label: '芯片类型',
  },
  {
    prop: 'versionOld',
    label: '旧版本',
  },
  {
    prop: 'versionNew',
    label: '升级版本',
  },
]

return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isDirectDevice.value)
      ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 0,
          description: "无数据"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(verseionText.value), 1),
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            data: tableData.value,
            class: "ws_common_table ws_mt24"
          }, {
            empty: _withCtx(() => [
              _createVNode(_component_el_empty, { description: "暂无数据" })
            ]),
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableColumn, (item, index) => {
                return _createVNode(_component_el_table_column, {
                  key: index,
                  prop: item.prop,
                  label: item.label,
                  formatter: item.formatter,
                  "show-overflow-tooltip": ""
                }, null, 8, ["prop", "label", "formatter"])
              }), 64)),
              _createVNode(_component_el_table_column, {
                width: 160,
                label: "升级结果"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_tag, {
                    type: statusMap[scope.row.upgradeResult]
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(textMap[scope.row.upgradeResult]), 1)
                    ]),
                    _: 2
                  }, 1032, ["type"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, { label: "升级时间" }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_unref(moment)(scope.row.createDate).format('YYYY-MM-DD HH:mm:ss')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, { label: "升级类型" }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.upgradeType), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, tableLoading.value]
          ]),
          _createVNode(_component_el_pagination, {
            class: "ws_mt50",
            "current-page": pageParams.value.curPage,
            "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((pageParams.value.curPage) = $event)),
            "page-size": pageParams.value.pageSize,
            "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((pageParams.value.pageSize) = $event)),
            "page-sizes": _unref(PAGE_SIZES),
            layout: "->, total, sizes, prev, pager, next, jumper ",
            total: total.value,
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
        ]))
  ]))
}
}

})